import { SVGProps, memo } from 'react';
const ShareIcon2 = (props: SVGProps<SVGSVGElement>) => (
<svg width={props.width || "16px"} height={props.height || "16px"}  viewBox="0 0 16 16" fill={props.fill || "none"} stroke={props.stroke || "none"} xmlns="http://www.w3.org/2000/svg">
<circle cx="3.5" cy="7.5" r="2"/><circle cx="12.5" cy="3.5" r="2"/><circle cx="12.5" cy="11.5" r="2"/><line  x1="5.381" y1="8.336" x2="10.624" y2="10.666"/><line  x1="10.75" y1="4.232" x2="5.249" y2="6.712"/>
</svg>
);

export default memo(ShareIcon2)